import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import MaintenanceSection from '../components/home/MaintenanceSection';
import { siteData } from '../data/content';
import CTASection from '../components/home/CTASection';

const serviceImages = [
  "https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1514316454349-750a7fd3da3a?auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1619551734325-81aaf323686c?auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1614026480209-cd9934144671?auto=format&fit=crop&q=80"
];

export default function Services() {
  return (
    <div>
      <PageHeader 
        title="Our Services" 
        subtitle="Comprehensive auto detailing tailored to your vehicle's specific needs."
        bgImage="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80"
      />
      
      <div className="py-24 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-24">
            {siteData.services.map((service, index) => (
              <div 
                key={service.id} 
                className={`flex flex-col md:flex-row gap-12 items-center ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
              >
                <div className="w-full md:w-1/2">
                  <div className="aspect-[4/3] bg-slate-900 rounded-sm overflow-hidden border border-slate-800 relative">
                    <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/20 to-transparent z-10" />
                    <img 
                      src={serviceImages[index]} 
                      alt={`${service.title} - A.R. Elite Detailing Jacksonville FL`}
                      className="w-full h-full object-cover opacity-90 hover:opacity-100 transition-opacity duration-500"
                    />
                  </div>
                </div>
                
                <div className="w-full md:w-1/2">
                  <div className="flex items-center gap-3 mb-4">
                    <SafeIcon name={service.icon} className="text-blue-500 text-2xl" />
                    <h2 className="text-3xl font-black text-white uppercase tracking-tight">{service.title}</h2>
                  </div>
                  <p className="text-xl text-slate-300 font-medium mb-4">{service.short}</p>
                  <p className="text-slate-400 mb-6 leading-relaxed">{service.desc}</p>
                  
                  <div className="mb-8">
                    <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-3">What's Included</h4>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {service.features.map((feature, i) => (
                        <li key={i} className="flex items-center gap-2 text-slate-400 text-sm">
                          <SafeIcon name="CheckCircle" className="text-blue-500 text-xs" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-slate-900 border-l-4 border-blue-600 p-4 mb-8">
                    <p className="text-sm text-slate-300">
                      <strong className="text-white uppercase text-xs tracking-wider">Ideal For:</strong> {service.ideal}
                    </p>
                  </div>
                  
                  <Button to="/contact" variant="outline">Request Quote</Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <MaintenanceSection />
      
      <CTASection />
    </div>
  );
}